module.exports = __webpack_public_path__ + "static/media/tracking-url-logo.3bbe7313.png";